import { css, SerializedStyles, useTheme } from "@emotion/react"
import React from "react"
import { Box, BoxProps } from "rebass"

type Props = {
  backgroundColor?: string
  additionalStyles?: SerializedStyles
} & BoxProps

export const Divider = ({
  backgroundColor,
  additionalStyles,
  ...rest
}: Props) => {
  const theme = useTheme()
  const dividerStyle = css`
    height: 1px;
    background-color: ${backgroundColor ?? theme.colors.ctaInactive};
    min-width: 100%;
    ${additionalStyles}
  `
  return <Box {...rest} css={dividerStyle}></Box>
}
